import { NeedsHistoryEntryDto } from '@act/shared/data-transfer-objects';
import { userAppSelectors } from 'redux/slices/usersSlice.slice';
import { visitsAppSelectors } from 'redux/slices/visitsSlice.slice';
import {
  StyledHistoryEntry,
  StyledHistoryEntrySubheader,
  getHistoryEntryDateLine,
} from './HistoryDisplay';

interface ResourceDetailsHistoryProps {
  historyEntry: NeedsHistoryEntryDto;
}

export const VisitHistoryEntry = ({
  historyEntry,
}: ResourceDetailsHistoryProps) => {
  const visit = visitsAppSelectors.useSelectVisitById(historyEntry.visitId);
  const creator = userAppSelectors.useSelectUserById(visit?.createdBy);
  const creatorName = creator?.name;

  return (
    <StyledHistoryEntry
      header={`Resource Visited: ${historyEntry.resource.title}`}
      content={
        <StyledHistoryEntrySubheader>
          {getHistoryEntryDateLine(historyEntry?.createdAt, creatorName)}
        </StyledHistoryEntrySubheader>
      }
    />
  );
};
